// import React from 'react';

function NotFound() {
  return (
    <div className="app">
      <h2>Not Found</h2>
    </div>
  );
}

export default NotFound;
